import { render, staticRenderFns } from "./TipNominator.vue?vue&type=template&id=ad68e90c&"
import script from "./TipNominator.vue?vue&type=script&lang=js&"
export * from "./TipNominator.vue?vue&type=script&lang=js&"
import style0 from "./TipNominator.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports